import React, { useEffect, useState } from "react";
import { FiClipboard } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import { useParams } from "react-router-dom";
import moment from "moment";

import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";

const ProblemsCard = ({ onExportData }) => {
  const params = useParams();

  const [data, setData] = useState([]);

  const Status = (St) => {
    if (St === "0") {
      return "Inactive";
    } else if (St === "1") {
      return "Active";
    } else {
      return "Resolved";
    }
  };

  const StatusClass = (St) => {
    if (St === "0") {
      return "inactive-status";
    } else if (St === "1") {
      return "active-status";
    } else {
      return "resolved-status";
    }
  };

  const getProblemsData = () => {
    axiosInstance
      .get("/vozonew/patient/medical_problem?pid=" + params.pid)
      .then((response) => {
        let decodingResponse = Decrypt_Value(response.data, "vozo");

        const formatted = (
          Array.isArray(decodingResponse) ? decodingResponse : []
        ).map((item) => ({
          diagnosis: item.diagnosis ? item.diagnosis.split("-")[2] || "-" : "-",

          diagnosedDate:
            item.begdate && item.begdate !== "0000-00-00"
              ? moment(item.begdate).format("MMM DD, YYYY")
              : "",

          status: Status(item.activity),

          activity: item.activity,
        }));

        /* UI → latest 3 */

        const latestThree = formatted.slice(0, 3);

        setData(latestThree);

        /* PARENT → FULL DATA */

        if (onExportData) {
          onExportData(
            formatted.map((item) => ({
              title: item.diagnosis,
              subText: item.diagnosedDate,
              status: item.status,
            })),
          );
        }
      })
      .catch(() => {
        setData([]);
      });
  };

  useEffect(() => {
    getProblemsData();
  }, [params.pid]);

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiClipboard className="care-summary-main-icon" />

        <h3 className="care-summary-title">Active Problems</h3>
      </div>

      <div className="care-summary-body">
        {data.map((item, index) => (
          <div
            key={index}
            className={`care-summary-row ${
              index !== data.length - 1 ? "care-summary-border" : ""
            }`}
          >
            <div className="care-summary-content">
              <div className="care-summary-heading">{item.diagnosis}</div>

              <div className="care-summary-subtext">
                Diagnosed: {item.diagnosedDate}
              </div>
            </div>

            <div
              className={`care-summary-status-wrap ${StatusClass(
                item.activity,
              )}`}
            >
              <span className="care-summary-status-dot"></span>

              <span className="care-summary-status-text">{item.status}</span>
            </div>
          </div>
        ))}

        {data.length === 0 && (
          <div className="care-summary-empty">No Problems Added</div>
        )}
      </div>
    </div>
  );
};

export default React.memo(ProblemsCard);
